import React, { useEffect, useState } from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import AboutPerks from "./components/AboutPerks";
import Gallery from "./components/Gallery";
import Footer from "./components/Footer";
import { FollowModal, FaqModal, LegalModal } from "./components/Modals";
import VipCheckout from "./components/VipCheckout";
import { BrowserRouter, Routes, Route, useNavigate, useSearchParams } from "react-router-dom";
import MemberApp from "./members/MemberApp";
import { getMemberToken } from "./lib/api";
import { SiteProvider } from "./context/SiteContext";
import AdminPage from "./admin/AdminPage";

function Landing() {
  const [vipOpen, setVipOpen] = useState(false);
  const [followOpen, setFollowOpen] = useState(false);
  const [faqOpen, setFaqOpen] = useState(false);
  const [legal, setLegal] = useState(null);
  const [active, setActive] = useState("home");
  const nav = useNavigate();
  const [params, setParams] = useSearchParams();
  const [vipTab, setVipTab] = useState("join");
  const isVip = !!getMemberToken();

  useEffect(() => {
    if (params.get("login")) { setVipTab("login"); setVipOpen(true); params.delete("login"); setParams(params, { replace: true }); }
  }, []); // eslint-disable-line

  useEffect(() => {
    const f = () => {
      const ids = ["gallery", "vip", "about"];
      const found = ids.find((id) => { const el = document.getElementById(id); return el && el.getBoundingClientRect().top < 200; });
      setActive(found || "home");
    };
    window.addEventListener("scroll", f);
    return () => window.removeEventListener("scroll", f);
  }, []);

  const onNav = (id) => {
    if (id === "faq") return setFaqOpen(true);
    if (id === "home") return window.scrollTo({ top: 0, behavior: "smooth" });
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };
  const openVip = () => {
    if (isVip) return nav("/members/chat");
    setVipTab("join"); setVipOpen(true);
  };
  const openLogin = () => { if (isVip) return nav("/members/chat"); setVipTab("login"); setVipOpen(true); };

  return (
    <div className="App">
      <Navbar onJoin={openVip} onLogin={openLogin} isMember={isVip} onNav={onNav} active={active} />
      <Hero onLogin={openLogin} onVip={openVip} onFollow={() => setFollowOpen(true)} />
      <AboutPerks onVip={openVip} isVip={isVip} />
      <Gallery onVip={openVip} isVip={isVip} />
      <Footer onLegal={setLegal} />

      <VipCheckout open={vipOpen} onOpenChange={setVipOpen} initialTab={vipTab} />
      <FollowModal open={followOpen} onOpenChange={setFollowOpen} />
      <FaqModal open={faqOpen} onOpenChange={setFaqOpen} />
      <LegalModal kind={legal} onOpenChange={(o) => !o && setLegal(null)} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <SiteProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/members" element={<MemberApp />} />
          <Route path="/members/:section" element={<MemberApp />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </SiteProvider>
    </BrowserRouter>
  );
}

export default App;
